<template>
	<v-row>
		<BottomNavigationContainer v-if="menu.length > 1" :menu="menu" />

		<v-col cols="12" class="d-none d-md-block">
			<ToolbarContainer :menu="menu" />
			<v-toolbar elevation="1" height="25" rounded="b">
				<Breadcrumbs />
			</v-toolbar>
		</v-col>

		<v-col cols="12" lg="12">
			<router-view />
		</v-col>
	</v-row>
</template>

<script>
import Breadcrumbs from "../Widgets/Breadcrumbs";
import ToolbarContainer from "../Widgets/ToolbarContainer";
import BottomNavigationContainer from "../Widgets/BottomNavigationContainer";

export default {
	name: "UsuarioContainer",
	components: { Breadcrumbs, ToolbarContainer, BottomNavigationContainer },
	data: () => ({
		menu: [],
		drawer: false,
		group: null,
		value: 0,
	}),
	methods: {
		montarMenu() {
			let m = [];

			if (this.permissao("usuario_listar")) {
				m.push({
					titulo: "Usuários",
					titulo_app: "Usuários",
					icon: "mdi-account-multiple-outline",
					to: "/usuario",
					tooltip: "Lista de usuários do sistema Gestor",
				});
			}

			if (this.permissao("grupo_listar")) {
				m.push({
					titulo: "Grupos",
					titulo_app: "Grupos",
					icon: "mdi-account-group-outline",
					to: "/usuario/grupo",
					tooltip: "Lista de grupos do sistema Gestor",
				});
			}

			this.menu = m;
		},
	},
	mounted() {
		this.montarMenu();
	},
};
</script>

<style scoped>
</style>